import {
    GET_CMS_IMAGE_LINKS_FOOTER,
    GET_CMS_TEXT_LINKS_FOOTER,
    GET_CMS_LOGO_SITIO_WEB_FOOTER
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;
    switch (type) {
        case GET_CMS_IMAGE_LINKS_FOOTER:
            return {
                ...state,
                imageLinks:payload.data
            }
        case GET_CMS_TEXT_LINKS_FOOTER:
            return {
                ...state,
                textLinks:payload.data
            }    
        case GET_CMS_LOGO_SITIO_WEB_FOOTER:
            return {
                ...state,
                logoSitioWeb: payload.data,
            }
        default:
            return state;
    }
};

export default cmsReducer;